

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PharmacyParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Pharmacy {
  salesCounterFlag:any;
  PharmacyCounterFlag:any;
  PrintAddressSelected:any;
  
    name: string;   
    mobile: string;
    gstn: string;
    dlno:string;
    email:string;

    doorno: string;
    address1: string;
    address2: string;
    city: string;
    district: string;
    state: string;
    country: string;
    landmark: string;
    pincode: string;
    
    
    reportLine1:string;
    reportLine2:string;
    reportLine3:string;
    reportLine4:string;
    reportLine5:string;

    reportLogo: string;
    reportMessage : string;


    tenantId?: string;
    branchId?: string;
    salesWarehouse:number;
    purchaseWarehouse:number;
  
    parameters?: PharmacyParameter[];
    links?: any;
}

export abstract class PharmacyData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Pharmacy[]>;
  abstract create(url: string,data: Pharmacy): Observable<any>;
  abstract update(url: string,data: Pharmacy): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
